/**
 * モックモードインジケーター
 * モックモードが有効な場合に画面上部に常時表示されるバナー
 */
import React from 'react';
import { Box, Typography, Chip, IconButton, Tooltip } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import StorageIcon from '@mui/icons-material/Storage';
import CloseIcon from '@mui/icons-material/Close';
import { isMockEnabled, disableMockMode } from '../utils/mockMode';

const MockModeIndicator: React.FC = () => {
  // モックモードが無効な場合は何も表示しない
  if (!isMockEnabled()) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: '#ff9800',
        background: 'linear-gradient(90deg, #ff9800 0%, #f57c00 50%, #ff9800 100%)',
        color: '#fff',
        padding: '6px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        boxShadow: '0 2px 8px rgba(0,0,0,0.3)',
        animation: 'mockBannerPulse 3s ease-in-out infinite',
        '@keyframes mockBannerPulse': {
          '0%, 100%': {
            opacity: 1,
          },
          '50%': {
            opacity: 0.85,
          },
        },
      }}
    >
      <BugReportIcon sx={{ fontSize: 20 }} />
      <Typography
        variant="body2"
        sx={{
          fontWeight: 600,
          letterSpacing: '0.5px',
        }}
      >
        モックモード実行中
      </Typography>
      <Chip
        icon={<StorageIcon sx={{ fontSize: 14, color: '#fff !important' }} />}
        label="バックエンド不要"
        size="small"
        sx={{
          backgroundColor: 'rgba(255,255,255,0.25)',
          color: '#fff',
          fontWeight: 500,
          fontSize: '0.7rem',
          height: 22,
          '& .MuiChip-icon': {
            color: '#fff',
          },
        }}
      />
      <Typography
        variant="caption"
        sx={{
          opacity: 0.9,
          fontSize: '0.7rem',
        }}
      >
        ダミーデータで動作しています
      </Typography>
      <Tooltip title="モックモードを終了">
        <IconButton
          size="small"
          onClick={disableMockMode}
          sx={{
            color: '#fff',
            padding: '2px',
            ml: 1,
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.2)',
            },
          }}
        >
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default MockModeIndicator;
